import { MediaItem } from "@/components/common/MediaItem";
import { useClientTelemetry } from "@/lib/clientTelemetry";

import type { AdsLandingResourceCardGrid } from "./types";

export function ResourceCardGrid({ cardGrid }: { cardGrid: AdsLandingResourceCardGrid }) {
  const { logEvent } = useClientTelemetry();

  if (cardGrid.cards.length === 0) {
    return null;
  }

  return (
    <div className="grid w-full grid-cols-1 gap-6 px-6 pt-[120px] sm:grid-cols-2 lg:grid-cols-4 lg:px-0">
      {cardGrid.cards.map((card) => {
        const content = (
          <>
            {card.media ?
              <MediaItem
                {...card.media}
                ratio={card.media.ratio ?? "1/1"}
                className="w-full rounded-[6px]"
              />
            : <div className="aspect-square w-full overflow-hidden rounded-[6px] bg-[rgba(0,0,0,0.04)]" />
            }
            <h3 className="text-primary text-[22px] leading-[1.26] font-medium text-balance">
              {card.title}
            </h3>
          </>
        );

        return card.href ?
            <a
              key={card.title}
              href={card.href}
              className="flex min-w-0 flex-col gap-4"
              target={card.external ? "_blank" : undefined}
              rel={card.external ? "noreferrer" : undefined}
              data-analytics-action={card.analyticsAction}
              onClick={() => {
                if (card.analyticsAction) {
                  logEvent("landing_resource_clicked", card.analyticsAction);
                }
              }}
            >
              {content}
            </a>
          : <article key={card.title} className="flex min-w-0 flex-col gap-4">
              {content}
            </article>;
      })}
    </div>
  );
}
